import './common_scenarios_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  switchCategoryType (categoryType) {
    this.commonListsControllers.map((controller) => {
      if (controller.categoryType === categoryType) {
        controller.show()
      } else {
        controller.hide()
      }
    })
  }

  get commonListsControllers () {
    return this.application.controllers.filter(controller => {
      return controller.context.identifier === 'common-lists'
    })
  }
}
